// This is an autogenerated file. Do not manually edit.
// Run `node packages/framework/owa-fluent-icons-svg/updateIcons.js` to update the icons in this package
import { createIconModule } from '../createIconModule';
import { ClassificationRegular } from '@fluentui/react-icons';

export default createIconModule(
    'ClassificationRegular',
    ClassificationRegular
) as 'ClassificationRegular';
